import { render, staticRenderFns } from "./AdminMandateTypeForm.vue?vue&type=template&id=3474c81f&scoped=true&"
import script from "./AdminMandateTypeForm.vue?vue&type=script&lang=js&"
export * from "./AdminMandateTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474c81f",
  null
  
)

export default component.exports